// libs
import React, { useState } from 'react';

// styles
import {
  FaqWrapper,
  Heading,
  FaqItem,
  FaqQuestion,
  FaqAnswer,
  Arrow,
  ViewMoreButton,
} from './styles';

// constants
import {
  faqList,
  ARROW_ICON_URL,
  RIGHT_ARROW_ICON_SIZE,
  FAQ,
  VIEW_MORE_FAQS,
  TERMS_AND_CONDITIONS,
} from './constants';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const { viewMoreUrl, TermsAndConditionUrl } = useRemoteConfig('rewardsPageData') || {};
  const ArrowRight = useStoreIcon(IconName.ARROW_RIGHT);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <FaqWrapper className="ftloker-wrap">
      <Heading className="faq-heading title-medium">{FAQ}</Heading>
      {faqList.map((faq, index) => (
        <FaqItem key={index} className="faq-item">
          <FaqQuestion className="faq-question title-xsmall" onClick={() => toggleFaq(index)}>
            {faq.question}
            <span className="arrow">
              <Arrow src={ARROW_ICON_URL} alt="Toggle" expanded={openIndex === index} />
            </span>
          </FaqQuestion>
          {openIndex === index && (
            <FaqAnswer className="faq-answer subtitle-medium">{faq.answer}</FaqAnswer>
          )}
        </FaqItem>
      ))}
      <ViewMoreButton onClick={() => window.open(viewMoreUrl, '_self')}>
        {VIEW_MORE_FAQS}
        <ArrowRight size={RIGHT_ARROW_ICON_SIZE} />
      </ViewMoreButton>
      <ViewMoreButton onClick={() => window.open(TermsAndConditionUrl, '_self')}>
        {TERMS_AND_CONDITIONS}
        <ArrowRight size={RIGHT_ARROW_ICON_SIZE} />
      </ViewMoreButton>
    </FaqWrapper>
  );
};

export default FAQs;
